import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MobileSessionService } from './mobile-session.service';

export const mobileAuthGuard: CanActivateFn = () => {
  const session = inject(MobileSessionService);
  const router = inject(Router);

  if (session.isLoggedIn()) {
    return true;
  }

  return router.parseUrl('/mobile/login');
};
